<div class="competence-form-wrapper">
  <h2 mat-dialog-title class="competence-form-title">
    <mat-icon>psychology</mat-icon>
    {{ isEditMode ? 'Редагувати компетенцію' : 'Нова компетенція' }}
  </h2>

  <mat-dialog-content>
    <form id="competenceForm" [formGroup]="form" (ngSubmit)="onSubmit()" class="competence-form">
      <div class="form-section">
        <h3 class="section-title">Компетенція</h3>

        <div class="form-row form-row--half">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Назва (канонічна)</mat-label>
            <input matInput formControlName="label" placeholder="Photographer" />
            @if (form.get('label')?.invalid && form.get('label')?.touched) {
            <mat-error>Назва обов'язкова</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Тип</mat-label>
            <mat-select formControlName="kind">
              @for (option of kindOptions; track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="form-section">
        <h3 class="section-title">Переклади</h3>
        <p class="section-hint">Порожнє поле — переклад буде видалено.</p>

        <div class="form-row form-row--triple">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>English</mat-label>
            <input matInput formControlName="enName" placeholder="Photographer" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Русский</mat-label>
            <input matInput formControlName="ruName" placeholder="Фотограф" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Українська</mat-label>
            <input matInput formControlName="ukName" placeholder="Фотограф" />
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="onCancel()">Скасувати</button>
    <button mat-raised-button color="primary" type="submit" form="competenceForm" [disabled]="form.invalid">
      {{ isEditMode ? 'Зберегти' : 'Створити' }}
    </button>
  </mat-dialog-actions>
</div>
